import React, { PropsWithChildren, useState } from "react";

type ScribeContextType = {
  initialized: boolean;
  setInitialized: (initialized: boolean) => void;
  showWritingAnimation: boolean;
  setShowWritingAnimation: React.Dispatch<React.SetStateAction<boolean>>;
  switchToQrCodeScribe: boolean;
  setSwitchToQrCodeScribe: (switchToQrCodeScribe: boolean) => void;
  showQrCode: boolean;
  setShowQrCode: (showQrCode: boolean) => void;
  hideScribaIntro: boolean;
  setHideScribaIntro: React.Dispatch<React.SetStateAction<boolean>>;
  reset: VoidFunction;
  fullName: string;
  setFullName: (fullName: string) => void;
};

const ScribeContext = React.createContext<ScribeContextType>({
  initialized: false,
  setInitialized: (initialized: boolean) => {},
  showWritingAnimation: false,
  setShowWritingAnimation: () => {},
  switchToQrCodeScribe: false,
  setSwitchToQrCodeScribe: () => {},
  showQrCode: false,
  setShowQrCode: (showQrCode: boolean) => {},
  hideScribaIntro: false,
  setHideScribaIntro: () => {},
  reset: () => {},
  fullName: "",
  setFullName: () => {},
});

const ScribeContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [initialized, setInitialized] = useState<boolean>(false);
  const [showWritingAnimation, setShowWritingAnimation] =
    React.useState<boolean>(false);
  const [switchToQrCodeScribe, setSwitchToQrCodeScribe] =
    useState<boolean>(false);
  const [showQrCode, setShowQrCode] = useState<boolean>(false);
  const [hideScribaIntro, setHideScribaIntro] = React.useState<boolean>(false);
  const [fullName, setFullName] = React.useState<string>("");

  const reset = () => {
    setInitialized(false);
    setShowWritingAnimation(false);
    setShowQrCode(false);
  };

  return (
    <ScribeContext.Provider
      value={{
        initialized,
        setInitialized,
        showWritingAnimation,
        setShowWritingAnimation,
        switchToQrCodeScribe,
        setSwitchToQrCodeScribe,
        showQrCode,
        setShowQrCode,
        hideScribaIntro: hideScribaIntro,
        setHideScribaIntro: setHideScribaIntro,
        reset,
        fullName,
        setFullName,
      }}
    >
      {children}
    </ScribeContext.Provider>
  );
};

const useScribeContext = () => React.useContext(ScribeContext);

export { ScribeContext, ScribeContextProvider, useScribeContext };
